// extracted by mini-css-extract-plugin
export default {"text-format":"About_text-format__uVkAE"};